import { render, staticRenderFns } from "./ClientVisitsConfirmModal.vue?vue&type=template&id=45f616c8"
import script from "./ClientVisitsConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ClientVisitsConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f616c8')) {
      api.createRecord('45f616c8', component.options)
    } else {
      api.reload('45f616c8', component.options)
    }
    module.hot.accept("./ClientVisitsConfirmModal.vue?vue&type=template&id=45f616c8", function () {
      api.rerender('45f616c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientVisitsConfirmModal.vue"
export default component.exports